import React from "react";

function NoNotifications(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 160 73" {...props}>
      <g filter="url(#NoNotifications__filter0_dd)">
        <path fill="#fff" d="M134 2H6a2 2 0 00-2 2v15a2 2 0 002 2h128a2 2 0 002-2V4a2 2 0 00-2-2z"></path>
      </g>
      <path fill="#E4E4E4" d="M69 8H24v2h45V8zm24 4H24v4h69v-4z"></path>
      <rect width="11" height="11" x="8" y="6" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <path fill="#005EE9" fillOpacity="0.2" d="M110.227 16.454a5.228 5.228 0 100-10.455 5.228 5.228 0 000 10.456z"></path>
      <path fill="#005EE9" fillOpacity="0.05" d="M124.227 16.454a5.228 5.228 0 100-10.455 5.228 5.228 0 000 10.456z"></path>
      <g filter="url(#NoNotifications__filter1_dd)">
        <path fill="#fff" d="M154 25H26a2 2 0 00-2 2v15a2 2 0 002 2h128a2 2 0 002-2V27a2 2 0 00-2-2z"></path>
      </g>
      <path fill="#E4E4E4" d="M89 31H44v2h45v-2zm24 4H44v4h69v-4z"></path>
      <rect width="11" height="11" x="28" y="29" fill="#F3D77D" rx="2"></rect>
      <path fill="#005EE9" fillOpacity="0.2" d="M130.227 39.455a5.228 5.228 0 100-10.456 5.228 5.228 0 000 10.456z"></path>
      <path fill="#005EE9" fillOpacity="0.05" d="M144.227 39.455a5.228 5.228 0 100-10.456 5.228 5.228 0 000 10.456z"></path>
      <g filter="url(#NoNotifications__filter2_dd)">
        <path fill="#fff" d="M134 48H6a2 2 0 00-2 2v15a2 2 0 002 2h128a2 2 0 002-2V50a2 2 0 00-2-2z"></path>
      </g>
      <path fill="#E4E4E4" d="M69 54H24v2h45v-2zm24 4H24v4h69v-4z"></path>
      <rect width="11" height="11" x="8" y="52" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <path fill="#005EE9" fillOpacity="0.2" d="M110.227 62.455a5.228 5.228 0 100-10.456 5.228 5.228 0 000 10.456z"></path>
      <path fill="#005EE9" fillOpacity="0.05" d="M124.227 62.455a5.228 5.228 0 100-10.456 5.228 5.228 0 000 10.456z"></path>
      <defs>
        <filter
          id="NoNotifications__filter0_dd"
          width="140"
          height="27"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoNotifications__filter1_dd"
          width="140"
          height="27"
          x="20"
          y="23"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoNotifications__filter2_dd"
          width="140"
          height="27"
          x="0"
          y="46"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default NoNotifications;